/**
 * React Query hook for polling tester server status
 *
 * Polls every 5 seconds to monitor device connection status
 * when WebSocket is not actively streaming test progress.
 */

import { useQuery } from "@tanstack/react-query";
import { versionTesterApi } from "../api/versionTesterApi";
import type { StatusResponse } from "../types";

/**
 * Hook to fetch and poll tester server status
 *
 * Returns current devices, running test state, and last result.
 * Automatically refetches every 5 seconds to keep status current.
 *
 * @returns useQuery result with StatusResponse data
 */
export const useTesterStatus = () => {
  return useQuery<StatusResponse>({
    queryKey: ["testerStatus"],
    queryFn: () => versionTesterApi.getStatus(),
    refetchInterval: 5000, // Poll every 5 seconds
    retry: 1, // Tester server may be offline, don't retry aggressively
  });
};
